<template>
  <EntityListItem
    icon="paper-plane"
    icon-tone="violet"
    :title="title"
    clickable
    @click="handleClick"
  >
    <template #subtitle>
      <span v-if="submission.form?.name" class="submission-list-item__meta">
        <BaseIcon name="form" size="11" />
        {{ submission.form.name }}
      </span>
      <span v-if="submission.email" class="submission-list-item__meta">
        <BaseIcon name="mail" size="11" />
        {{ submission.email }}
      </span>
    </template>

    <template #right>
      <span class="submission-list-item__when">
        <BaseIcon name="clock" size="11" />
        {{ relativeText }}
      </span>
    </template>
  </EntityListItem>
</template>

<script>
  import { computed, getCurrentInstance } from 'vue';
  import { useRouter } from 'vue-router';
  import dayjs from 'dayjs';
  import EntityListItem from '@/components/partials/lists/EntityListItem.vue';
  import BaseIcon from '@shared/components/BaseIcon.vue';

  export default {
    name: 'SubmissionListItem',

    components: { EntityListItem, BaseIcon },

    props: {
      submission: { type: Object, required: true },
    },

    emits: ['click'],

    setup(props, { emit }) {
      const instance = getCurrentInstance();
      const $t = instance.appContext.config.globalProperties.$t;
      const router = useRouter();

      const title = computed(
        () =>
          props.submission.lead?.name ||
          props.submission.contact_name ||
          props.submission.email ||
          $t('home.requests.untitled')
      );

      const relativeText = computed(() => {
        const iso = props.submission.created_at || props.submission.submitted_at;
        if (!iso) return '';
        const d = dayjs(iso);
        const diffMin = dayjs().diff(d, 'minute');
        if (diffMin < 1) return $t('home.just_now');
        if (diffMin < 60) return $t('home.minutes_ago', { n: diffMin });
        const diffHour = dayjs().diff(d, 'hour');
        if (diffHour < 24) return $t('home.hours_ago', { n: diffHour });
        const diffDay = dayjs().diff(d, 'day');
        if (diffDay < 7) return $t('home.days_ago', { n: diffDay });
        return d.format('DD MMM');
      });

      const handleClick = () => {
        emit('click', props.submission);
        if (props.submission.id) {
          router.push(`/submissions/${props.submission.id}`);
        }
      };

      return { title, relativeText, handleClick };
    },
  };
</script>

<style scoped lang="scss">
  .submission-list-item {
    &__meta {
      display: inline-flex;
      align-items: center;
      gap: 0.25rem;
    }

    &__when {
      display: inline-flex;
      align-items: center;
      gap: 0.25rem;
      font-size: 0.75rem;
      color: var(--slate-500);
      font-variant-numeric: tabular-nums;
      white-space: nowrap;

      .icon {
        color: var(--slate-400);
      }
    }
  }
</style>
